<template>
    <div>
        <gofix-default-table
                class="noFullHeight scrollAbsolute"
                :settings="tableConfig"
                :table-items="tableItems"
                @load-items="getTableDataFMCode"
                @new-item="createFMCodeModal"
                @row-click="goToDetail"
                @delete-items="deleteItems"
                ref="gofixTableFMCode">
            <template slot="gofix_table:financeLimit" slot-scope="row">
                {{ row.item.financeLimit | formatMoney }}
            </template>
            <template slot="gofix_table:name_service" slot-scope="row">
                {{ row.item.service_category ? row.item.service_category.name : '' }}
            </template>
            <template slot="gofix_table:is_charge_customer" slot-scope="row">
                {{ row.item.is_charge_customer ? 'Yes' : 'No' }}
            </template>
        </gofix-default-table>
        <b-modal :no-close-on-backdrop="true" modal-class="createFmCode" id="modal-Create" :title="models.title" hide-footer :centered="true" v-model="models.open" @hidden="hiddenModel">
            <b-form class="pb-20">
                <gofix-form-input label="FM code" v-model="models.data.fm_code"></gofix-form-input>
                <gofix-form-input label="Description" v-model="models.data.description"></gofix-form-input>
                <gofix-form-tree
                        label="Service Category"
                        :multiple="false"
                        :options="models.serviceCategories.data"
                        :load-options="loadOptionServices"
                        search-nested
                        v-model="models.data.service_category"
                        :normalizer="normalizerServices"
                        placeholder=""
                        valueFormat="object"
                        :defaultExpandLevel="1">
                </gofix-form-tree>

                <gofix-form-properties
                        label="Property"
                        :contract-id="$route.params.id"
                        search-nested
                        valueFormat="object"
                        v-model="models.data.property">
                </gofix-form-properties>

                <gofix-form-dropdown
                        label="Work Type"
                        v-model="models.data.work_type"
                        :options="models.optionWorTypes">
                </gofix-form-dropdown>
                <gofix-form-dropdown
                        label="GL Code"
                        :getOptionLabel="getOptionLabel"
                        :filterable="false"
                        @search="searchCOA"
                        v-model="models.data.coa"
                        :options="models.COA.data">
                </gofix-form-dropdown>
                <gofix-form-dropdown
                        label="GL Account Group"
                        v-model="models.data.gl_account_group"
                        :options="models.optionGLAccountGroup">
                </gofix-form-dropdown>
                <b-form-checkbox v-model="models.data.is_charge_customer" class="ml-3 checkbox-top-5"><span class="ml-3">Charge to customer</span></b-form-checkbox>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="createFmCode" :loading="models.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js';

    export default {
        name: 'fm-codes',
        components: {},
        data () {
            let filterFmcode = JSON.parse(JSON.stringify(filters['fm_codes']));
            return {
                tableConfig:{
                    name: 'finance-fm-codes',
                    controls:{
                        create: this.$checkRole(this.$accessModule.client_contract_finance, 'create'),
                        createTooptip:"Create FM Codes",
                        delete: this.$checkRole(this.$accessModule.client_contract_finance, 'delete'),
                        tableExport: false
                    },
                    filter: filterFmcode,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: false,
                    sortColumn: "fm_code",
                    sortDirection: "asc",
                    itemSelected: [],
                },
                tableItems:[],
                models:{
                    open: false,
                    loading: false,
                    title:"Create FM Codes",
                    data:{
                        id: null,
                        service_category_id: null,
                        service_category: null,
                        property_id: null,
                        property: null,
                        coa: null,
                        fm_code: null,
                        gl_code: null,
                        work_type: null,
                        description: null,
                        is_charge_customer: null,
                        contract_id: this.$route.params.id,
                    },
                    optionWorTypes: ['Preventive', 'Corrective', 'Reactive'],
                    optionGLAccountGroup: ['Expenses', 'Revenue'],
                    COA:{
                        data : [],
                        timmer: null,
                    },
                    serviceCategories : {
                        data: [],
                        loading: false
                    },
                    properties : {
                        data: [],
                        loading: false
                    }
                },
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID',
                currentRoles: 'AuthController/roles',
            }),
        },
        watch: {
            "currentRoles": function(val,old){
                this.tableConfig.controls = {
                    create: this.$checkRole(this.$accessModule.client_contract_finance, 'create'),
                    createTooptip:"Create FM Codes",
                    delete: this.$checkRole(this.$accessModule.client_contract_finance, 'delete')
                }
            },
            "ClientContractID": function(val){
                if(val){
                    this.$refs.gofixTableFMCode.reloadTableItems();
                }
            },
            "ClientContractID.finance_company": function(val){
                this.loadCOA();
            },
            "ClientContractID.id": function(val,old){
                if(old && old !== val){
                    if(val){
                        this.loadServiceCategory();
                        this.loadproperty();
                        this.models.data.contract_id = val;
                    }
                }
                this.loadCOA();
            }
        },
        created() {
            //this.loadServiceCategory();
            //this.loadproperty();
            this.loadCOA();
        },
        methods:{
            async createFMCodeModal(){
                if(this.models.properties.data.length === 0){
                    this.loadproperty();
                }
                if(this.models.serviceCategories.data.length === 0){
                    this.loadServiceCategory();
                }
                
                this.models.open = true
            },
            /*---------------------Fm code------------------*/
            async getTableDataFMCode(callback){
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.contract_id = this.ClientContractID.id;
                await this.$store.dispatch("FmCodeController/getFmCodeItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load items", "danger");
                        reject();
                    })
            },
            goToDetail(item){
                if(this.models.properties.data.length === 0){
                    this.loadproperty();
                }
                
                if(this.models.serviceCategories.data.length === 0){
                    this.loadServiceCategory();
                }
                this.models.title = 'Edit FM Codes';
                this.models.data = Object.assign({}, {
                    id: item.id,
                    service_category_id: item.service_category_id,
                    property_id: item.property_id,
                    property: item.property,
                    service_category: item.service_category,
                    coa: item.chart_of_account,
                    fm_code: item.fm_code,
                    gl_code: item.gl_code,
                    work_type: item.work_type,
                    gl_account_group: item.gl_account_group,
                    description: item.description,
                    is_charge_customer: item.is_charge_customer || false,
                    contract_id: this.$route.params.id,
                });
                this.models.open = true;

            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("FmCodeController/deleteFmCode", ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'fm_code'));
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },
            createFmCode(){
                if (!this.models.data.coa) {
                    return this.$alertNotification("Gl Code is a required field.", "danger");
                }
                if (!this.models.data.service_category) {
                    return this.$alertNotification("Service Category is a required field.", "danger");
                }
                if (!this.models.data.property) {
                    return this.$alertNotification("Property is a required field.", "danger");
                }
                if (!this.models.data.gl_account_group) {
                    return this.$alertNotification("Gl Account Group is a required field.", "danger");
                }

                this.models.loading = true;
                let keyMessage= 'adding'
                if(this.models.data && this.models.data.id) {
                    keyMessage = 'editing'
                }
                this.$store.dispatch('FmCodeController/saveFmCode', this.models.data)
                    .then(result => {
                        this.$refs.gofixTableFMCode.reloadTableKeepFilter();
                        this.$alertNotification(this.$notificationV2(keyMessage, 'fm_code'));
                        this.models.loading = false;
                        this.models.open = false;
                    })
                    .catch(error => {
                        this.models.loading = false;
                        if(error.response) {
                            if(error.response.data.error.message.error) this.$alertNotification(error.response.data.error.message.error, "danger");
                            this.$alertNotification("Error", "danger");
                        } 
                    })
            },

            /*---- Load data -----------------------*/
            loadServiceCategory(){
                this.models.serviceCategories.loading = true;
                this.$store.dispatch('ServiveCategoryController/getServiceCategories', {
                    contractId: this.$route.params.id,
                    categoryId: 0
                }).then(response => {
                    this.models.serviceCategories.loading = false;
                    this.models.serviceCategories.data = response;
                })
                    .catch(err => {
                        console.log(err);
                        this.models.serviceCategories.loading = false;
                        this.models.serviceCategories.data = [];
                    });
            },
            loadproperty(){
                this.models.properties.loading = true;
                this.$store.dispatch('FmCodeController/getProperties', {
                    contractId: this.$route.params.id,
                    propertyId: 0
                }).then(response => {
                    this.models.properties.loading = false;
                    this.models.properties.data = response;
                })
                    .catch(err => {
                        console.log(err);
                        this.models.properties.loading = false;
                        this.models.properties.data = [];
                    });
            },

            loadCOA(){
                this.$store.dispatch("FmCodeController/getCOA",{
                    limit: 100,
                    page: 1,
                    filter:{
                        coa_company_id: this.ClientContractID.finance_company ? this.ClientContractID.finance_company.finance_company_id : -1
                    }
                })
                    .then( response => {
                        this.models.COA.data = response.items;
                    })
                    .catch( err => {
                        console.log(err);
                    });
            },
            searchCOA(search, loading){
                loading(true);
                if(this.models.COA.timer) {
                    clearTimeout(this.models.COA.timer);
                    this.models.COA.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.$store.dispatch( 'FmCodeController/getCOA', {
                        limit: 100,
                        filter: {
                            search: search,
                            coa_company_id: this.ClientContractID.finance_company ? this.ClientContractID.finance_company.finance_company_id : -1
                        }
                    })
                        .then(response => {
                            this.models.COA.data = response.items;
                            loading(false)
                        })
                        .catch(err=>{ loading(false) })
                }, 500);
            },

            /*---- Models -----------------------*/
            hiddenModel(){
                this.models.title = "Create FM Codes";
                this.models.data = {
                    id: null,
                    service_category_id: null,
                    service_category: null,
                    property_id: null,
                    property: null,
                    coa: null,
                    fm_code: null,
                    gl_code: null,
                    work_type: null,
                    description: null,
                    contract_id: this.$route.params.id,
                }
            },

            /*---- Tree attribute -----------------------*/
            loadOptionServices({action, parentNode, callback}) {
                if (parentNode.isBatch) {
                    this.$store.dispatch("ServiveCategoryController/getServiceCategories", {
                        contractId: this.$route.params.id,
                        categoryId: parentNode.id
                    }).then(data => {
                        parentNode.children = data;
                        callback();
                    })
                } else {
                    callback();
                }
            },
            normalizerServices(node) {
                if (node.isBatch)
                    return {
                        label: node.name,
                        children: node.children
                    };
                return {
                    label: node.name,
                    children: undefined
                }
            },
            getOptionLabel(option){
                let label = option.gl_code + " " + option.name;
                return label;
            },


        }
    }
</script>
